import { Button } from '@catering/ui';
import type { JSX } from 'react';

import { usePwaUpdate } from './use-pwa-update';

/** Mounted once next to the router: announces a waiting service worker version. */
export function PwaUpdatePrompt(): JSX.Element | null {
  const { needRefresh, applyUpdate } = usePwaUpdate();

  if (!needRefresh) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 left-4 z-50 flex max-w-sm items-center gap-3 rounded-lg border border-sky-200 bg-white p-3 text-sm text-sky-900 shadow-lg"
    >
      <span>Hay una versión nueva</span>
      <span aria-hidden="true">—</span>
      <Button onClick={applyUpdate}>Actualizar</Button>
    </div>
  );
}
